import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from '../storage/storage.service';
import { HttpClient } from '@angular/common/http';
import { of, BehaviorSubject } from 'rxjs';
import {
  FiltersComponentInterface, FiltersTypeEnum, IFilterComboComponent,

} from 'world-archery-lib';
import { first, filter, tap, map, distinctUntilChanged } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { TranslocoService } from '@ngneat/transloco';
@Injectable()
export class LanguageService {
  filtersType: FiltersComponentInterface = [

    {
      options: {
        type: FiltersTypeEnum.ComboBox,

        name_filter: 'Language: ',
        options_subject: new BehaviorSubject<Array<any>>([
        ]),
        option_name_property: 'LanguageEN',
        options_selected_subject: new BehaviorSubject<any>({}),
        initial_state: true,
        id: 'wlang'
      } as IFilterComboComponent
    }
  ];
  constructor(
    private translateService:TranslocoService,
    private router: ActivatedRoute,
     private nav: Router,
      private storage: StorageService,
       private http: HttpClient) {
    this.lang().asObservable().pipe(filter(a => a != null && a !== '' && Object.keys(a).length !== 0)).subscribe(next => {
      this.selectLang(next);
      this.nav.navigate([], { queryParamsHandling: "preserve" });
      this.translateService.setActiveLang((next as any).LangID.toLowerCase());
    });
    this.http.get('https://api.worldarchery.sport/v3/RB-LANGUAGES/').pipe(
      first(), map(next => {
        const firstLang = this.getLang().LangID ? this.getLang() : (next as any).items.find(value => value.LangID === 'EN');
        this.langs = ((next as any).items) as any;
        return firstLang;
      }), tap(next => {
        if (next instanceof Object) {
          (this.filtersType[0].options as IFilterComboComponent).options_selected_subject.next(next);
        }
      })
    ).subscribe(next => {
    });
  }
  get loading() {
    return this.storage.loading;
  }
  public selectLang(lang: string) {
    this.storage.putLang(lang);
  }
  public getLang() {

    return this.storage.getLang();
  }
  public storeLangs(langs: Array<any>) {
    this.storeLangs(langs);
  }
  public getLangs() {
    return this.storage.getLangs();
  }
  lang() {
    return (this.filtersType[0].options as IFilterComboComponent).options_selected_subject;
  }
  get langs() {
    return (this.filtersType[0].options as IFilterComboComponent).options_subject as any;
  }
  set langs(lang: Array<any>) {
    (this.filtersType[0].options as IFilterComboComponent).options_subject.next(lang);
  }
}
